import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { CookieSetting } from "cookiesetting-component";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import MainPage from "./components/MainPage/MainPage";
import AnimatedGradient from "./components/AnimatedGradient/AnimatedGradient";
import "./components/styles/globals.css";
function App() {
  const isProduction = process.env.NODE_ENV === "production";

  return (
    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={isProduction}
      isVerboseMode={false}
      metaFileDirectory={"."}
    >
      <>
        <AnimatedGradient />
        <Router>
          <Routes>
            <Route path="/homeownership" element={<MainPage />} />
            <Route path="/homeownership/:loName" element={<MainPage />} />
          </Routes>
        </Router>
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />
      </>
    </CacheBuster>
  );
}

export default App;
